import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment';

import {
  Employee,
  FertilizationLegalStandards,
  GenerateFromManureSpaceRequest,
} from '../fertilization-legal-standards.models';

@Injectable({
  providedIn: 'root',
})
export class FertilizationLegalStandardsService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES
    ? `${this.env.APIM_BASE_URL}/arable-service/manure-space/fertilization-legal-standard`
    : `${this.env.API_BASE_URL}/service/field-report/secure/fertilizationlegalstandard/manureSpace`;

  protected fieldAdviceUrl = this.env.FIELD_ADVICE_REBUILD_DONE
    ? `${this.env.APIM_BASE_URL}/arable-service/advice/`
    : this.env.API_BASE_URL + '/service/field-advice/secure/';

  getFertilizationLegalStandards(request: GenerateFromManureSpaceRequest) {
    return this.http.post<FertilizationLegalStandards>(this.baseUrl, request);
  }

  getLoggedInEmployee() {
    return this.http.get<Employee>(`${this.fieldAdviceUrl}loggedinemployee`);
  }
}
